import React, { useMemo } from "react";
import { Link, withRouter } from "react-router-dom";
import { getLandingConfig } from "./applicationLandings";
import "./Applications.css";

function ApplicationSuccessPage({ location }) {
  const params = new URLSearchParams(location.search || "");
  const type = params.get("type") || "organization";
  const config = getLandingConfig(type);

  const receipt = useMemo(() => {
    try {
      const raw = window.sessionStorage.getItem("tpg_application_receipt");
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }, []);

  return (
    <div className="community-page apply-landing">
      <header className="community-page__hero">
        <div className="community-page__shell">
          <p className="community-page__eyebrow">Pentecost+</p>
          <h1 className="community-page__title">Application submitted</h1>
          <p className="community-page__lede">
            Thank you. Your {config.type} application is pending review. We will
            contact you at the email you provided.
          </p>
        </div>
      </header>
      <main className="community-page__shell apply-landing__main">
        <section className="apply-success">
          {receipt ? (
            <dl className="apply-success__meta">
              <div>
                <dt>Reference</dt>
                <dd>
                  <code>{receipt.unique_id}</code>
                </dd>
              </div>
              <div>
                <dt>Name</dt>
                <dd>{receipt.name}</dd>
              </div>
              <div>
                <dt>Status</dt>
                <dd>{receipt.status_label || receipt.status}</dd>
              </div>
            </dl>
          ) : null}
          <p className="apply-landing__notice" role="note">
            Submission of an application does not guarantee approval.
          </p>
          <div className="apply-landing__cta-row">
            <Link className="btn btn-danger" to={config.path}>
              Back to {config.title}
            </Link>
            <Link className="btn btn-outline-light" to="/">
              Home
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
}

export default withRouter(ApplicationSuccessPage);
